import { render } from "./NewOrderSummary.vue?vue&type=template&id=1b4279c4&scoped=true&ts=true"
import script from "./NewOrderSummary.ts?vue&type=script&lang=ts"
export * from "./NewOrderSummary.ts?vue&type=script&lang=ts"

import "./NewOrderSummary.vue?vue&type=style&index=0&id=1b4279c4&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4279c4"]])

export default __exports__